import { useEffect, useState } from 'react';

export default function useTheme() {
	const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

	useEffect(() => {
		document.documentElement.setAttribute('data-theme', theme);
		// document.documentElement.setAttribute('data-bs-theme', theme);
		localStorage.setItem('theme', theme);
	}, [theme]);

	const toggleTheme = () => {
		setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
	};

	return [theme, toggleTheme];
}
